import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "frame"]

  connect() {
    this._onKeydown = this._onKeydown?.bind(this) || ((e) => {
      if (e.key === "Escape") this.close()
    })
  }

  open(event) {
    event?.preventDefault()
    event?.stopPropagation()

    const url = event?.currentTarget?.dataset?.url
    if (!url) return

    // Show modal
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")

    // Focus the dialog container for accessibility (outer white panel)
    this.modalTarget.querySelector('[role="dialog"]')?.focus()

    // Reset content then set src attribute (Turbo will load the frame URL)
    this._setFrameHTML('<div class="p-6 text-slate-600 text-sm">Loading…</div>')
    this.frameTarget.setAttribute("src", url)
  }

  close(event) {
    event?.preventDefault()

    // Clear the frame to avoid stale content or background requests
    this.frameTarget.removeAttribute("src")
    this._setFrameHTML('<div class="p-6 text-slate-600 text-sm">Loading…</div>')

    // Hide modal
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  backdrop(event) {
    // close if clicking the outer wrapper OR the backdrop layer
    if (event.target === this.modalTarget || event.target.classList.contains("js-quickview-backdrop")) {
      this.close(event)
    }
  }

  // Optional: listen for Esc while modal is open
  showKeyboardShortcuts() {
    document.addEventListener("keydown", this._onKeydown)
  }
  hideKeyboardShortcuts() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  // When the modal becomes visible/hidden, manage the Esc listener
  modalTargetConnected(element) {
    if (!element.classList.contains("hidden")) this.showKeyboardShortcuts()
  }
  modalTargetDisconnected() {
    this.hideKeyboardShortcuts()
  }

  _onKeydown(e) {
    if (e.key === "Escape") this.close()
  }

  _setFrameHTML(html) {
    // Safely replace the frame’s inner content
    this.frameTarget.innerHTML = html
  }
}
